import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  overflow-x: auto;
  gap: ${theme.spacing.xm};
  max-height: 450px;
`
export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
`

export const GridContainer = styled.form`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  gap: ${theme.spacing.sm};

  // First Row
  .grid-1-3 {
    grid-column: 1 / 3;
  }

  .grid-3-5 {
    grid-column: 3 / 5;
  }

  .grid-5-7 {
    grid-column: 5 / 7;
  }

  .grid-7-9 {
    grid-column: 7 / 9;
  }

  .grid-9-11 {
    grid-column: 9 / 11;
  }

  .grid-11-13 {
    grid-column: 11 / 13;
  }

  // Second Row
  .grid-1-7 {
    grid-column: 1 / 7;
  }

  .grid-7-12 {
    grid-column: 7 / 12;
  }

  .grid-12-13 {
    grid-column: 12 / 13;
  }
`

export const TabsWrapper = styled.div`
  width: 100%;

  #action-tabs-wrap {
    margin: 0;
    padding: 0;

    button {
      font-size: ${theme.typography.sizes.xs};
      padding: ${theme.spacing.sm};
      font-family: ${theme.typography.family.primary};
      font-weight: ${theme.typography.weight.sm};
    }
  }
`
